import Player from "../../pages/player/Player";
import Inventory from "./data/item/Inventory";
import Mail from "./data/mail/Mail";
import StoreInfo from "./data/storeInfo/StoreInfo";
import Character from "./data/character/Character";
import Mission from "./data/mission/Mission";
import Collection from "./data/collection/Collection";
import {PassChain} from "./data/passChain/PassChain";
import PlayInfo from "./data/playInfo/PlayInfo";
import Monthly from "./data/monthly/Monthly";
import MergeGrid from "./data/playScreen/MergeGrid";
import Payment from "./log/Payment";
import CouponUse from "./log/CouponUse";
import PlayerMailLog from "./log/PlayerMailLog";
import PlayerLoginLog from "./log/PlayerLoginLog";
import PlayerCsLog from "./log/PlayerCSLog";
import PlayerGoodsLog from "./log/PlayerGoodsLog";
import PlayerGachaLog from "./log/PlayerGachaLog";
import PlayerMiracleBadgeLog from "./log/PlayerMiracleBadgeLog";
import PlayerEventTruckLog from "./log/PlayerEventTruckLog";
import PlayerLuckyArcadeLog from "./log/PlayerLuckyArcadeLog";
import PlayerRankingChallengeLog from "./log/PlayerRankingChallengeLog";
import PlayerPlazaPointLog from "./log/PlayerPlazaPointLog";
import PlayerCostumePurchaseLog from "./log/PlayerCostumePurchaseLog";
import MergeEventGrid from "./data/mergeEvent/MergeEventGrid";
import GuideMission from "./data/guideMission/GuideMission";
import PlayerErrorLog from "./log/PlayerErrorLog";
import MergeEventBugCompensationPage from "./data/etc/MergeEventBugCompensationPage";
import SeasonMissionViewer from "./data/etc/SeasonMissionViewer";
import CharacterPackage from "./data/characterPackage/CharacterPackage";
import Invite from "./data/invite/Invite";
import CorruptData from "./data/corruptData/CorruptData";
import PlayerShoppingRoad from "./data/shoppingRoad/PlayerShoppingRoad";
import MergeEventGridBoss from "./data/mergeEvent/MergeEventGridBoss";
import PlayerTrophy from "./data/trophy/PlayerTrophy";
import MyDreamPartner from "./data/myDreamPartner/MyDreamPartner";
import PlayerPartnerLog from "./log/PlayerPartnerLog";
import CharacterCafePage from "./data/characterCafe/CharacterCafePage";
import PlayerClaw from "./data/claw/PlayerClaw";
import PlayerBalloon from "./data/balloon/PlayerBalloon";
import PlayerTruck from "./data/truck/PlayerTruck";
import Prosperity from "./data/prosperity/Prosperity";
import ThreeDayStreak from "./data/threeDayStreak/ThreeDayStreak";
import TwinRoulette from "./data/twinRoulette/TwinRoulette";
import ColorTargetBoard from "./data/colorTarget/ColorTargetBoard";
import Profile from "./data/profile/Profile";
import PlayerProfileLog from "./log/PlayerProfileLog";
import PlayerDiceRaceLog from "./log/PlayerDiceRaceLog";

export const playerRoutes = {
    path: "/player", component: <Player/>, children: [
        {path: "/player/data/item", component: <Inventory/>},
        {path: "/player/data/mail", component: <Mail/>},
        {path: "/player/data/store", component: <StoreInfo/>},
        {path: "/player/data/character", component: <Character/>},
        {path: "/player/data/mission", component: <Mission/>},
        {path: "/player/data/collection", component: <Collection/>},
        {path: "/player/data/passChain", component: <PassChain/>},
        {path: "/player/data/playInfo", component: <PlayInfo/>},
        {path: "/player/data/monthly", component: <Monthly/>},
        {path: "/player/data/merge", component: <MergeGrid/>},
        {path: "/player/data/mergeEvent", component: <MergeEventGrid/>},
        {path: "/player/data/mergeEventBoss", component: <MergeEventGridBoss/>},
        {path: "/player/data/guideMission", component: <GuideMission/>},
        {path: "/player/data/mergeEventBug", component: <MergeEventBugCompensationPage/>},
        {path: "/player/data/seasonMissionViewer", component: <SeasonMissionViewer/>},
        {path: "/player/data/characterPackage", component: <CharacterPackage/>},
        {path: "/player/data/inviteFriend", component: <Invite />},
        {path: "/player/data/corruptData", component: <CorruptData/>},
        {path: "/player/data/shoppingRoad", component: <PlayerShoppingRoad/>},
        {path: "/player/data/trophy", component: <PlayerTrophy/>},
        {path: "/player/data/myDreamPartner", component: <MyDreamPartner/>},
        {path: "/player/data/characterCafe", component: <CharacterCafePage/>},
        {path: "/player/data/claw", component: <PlayerClaw/>},
        {path: "/player/data/balloon", component: <PlayerBalloon/>},
        {path: "/player/data/truck", component: <PlayerTruck/>},
        {path: "/player/data/prosperity", component: <Prosperity/>},
        {path: "/player/data/threeDayStreak", component: <ThreeDayStreak/>},
        {path: "/player/data/twinRoulette", component: <TwinRoulette/>},
        {path: "/player/data/colorTarget", component: <ColorTargetBoard/>},
        {path: "/player/data/profile", component: <Profile/>},

        {path: "/player/log/purchase", component: <Payment/>},
        {path: "/player/log/couponUse", component: <CouponUse/>},
        {path: "/player/log/mail", component: <PlayerMailLog/>},
        {path: "/player/log/login", component: <PlayerLoginLog/>},
        {path: "/player/log/cs", component: <PlayerCsLog/>},
        {path: "/player/log/goods", component: <PlayerGoodsLog/>},
        {path: "/player/log/gacha", component: <PlayerGachaLog />},
        {path: "/player/log/error", component: <PlayerErrorLog />},
        {path: "/player/log/partner", component: <PlayerPartnerLog/>},
        {path: "/player/log/miracleBadge", component: <PlayerMiracleBadgeLog/>},
        {path: "/player/log/eventTruck", component: <PlayerEventTruckLog/>},
        {path: "/player/log/luckyArcade", component: <PlayerLuckyArcadeLog/>},
        {path: "/player/log/profile", component: <PlayerProfileLog/>},
        {path: "/player/log/rankingChallenge", component: <PlayerRankingChallengeLog/>},
        {path: "/player/log/plazaPoint", component: <PlayerPlazaPointLog/>},
        {path: "/player/log/costumePurchase", component: <PlayerCostumePurchaseLog/>},
        {path: "/player/log/diceRace", component: <PlayerDiceRaceLog/>}
    ]
}